/**
 * Login Component
 * @author Juan Carlos Cancela <cancela.juancarlos@gmail.com>
 */
/* global $ */
/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */
/* eslint-disable */

import React from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import _ from 'lodash';
import * as authActions from '../../actions/authActions';
import {
  LOCALSTORAGE_AUTH_KEY,
  LOGIN_STATUS_PENDING,
  LOGIN_STATUS_NOT_LOGGED_IN,
  HOST_SERVER,
} from '../../constants';
import s from './Login.css';
import Link from '../Link';
import ModalErrorLogin from '../Login/ModalErrorLogin/ModalErrorLogin';
import ModalUsuarioBloqueado from '../Login/ModalUsuarioBloqueado/ModalUsuarioBloqueado';
import ModalUsuarioNoRegistrado from '../Login/ModalUsuarioNoRegistrado/ModalUsuarioNoRegistrado';
import ModalErrorConexionLogin from '../Login/ModalErrorConexionLogin/ModalErrorConexionLogin';
import ModalAltaPendiente from '../Login/ModalAltaPendiente/ModalAltaPendiente';
import ModalError from '../Telemedicina/ModalError/ModalError';

class Login extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loginStatus: LOGIN_STATUS_PENDING,
      showLoginPop: false,
      showUserPop: false,
      errorPassword: false,
      numError: '',
      fechaAlta: '',
      dataErrorLogin: '',
    };
  }

  componentDidMount() {
    const auth = localStorage.getItem(LOCALSTORAGE_AUTH_KEY);
    if (_.isEmpty(auth)) {
      this.setState({ loginStatus: LOGIN_STATUS_NOT_LOGGED_IN });
    } else {
      this.props.authSuccess(JSON.parse(auth));
    }
    $('body').on('keypress', e => {
      if (e.which === 13) {
        this.onLoginDataSubmit();
      }
    });
  }

  componentWillReceiveProps(props) {
    if (!_.isEmpty(props.loginError)) {
      /*console.log('LOGIN ERROR');
      console.log(props.loginError);
      console.log(props.loginError.data.errNumber);*/
      this.setState({ errorPassword: true,
        numError: props.loginError.data ? props.loginError.data.errNumber : props.loginError,
        dataErrorLogin: props.loginError});
      //this.setState({ errorPassword: true, numError: '1003', dataErrorLogin: {data:{errInfo:{fechaAlta:'20190129'}}}});
      this.props.cleanAuthLogin();
      this.props.cleanLoginError();
    }

    if (
      _.isEmpty(props.auth) &&
      this.state.loginStatus !== LOGIN_STATUS_NOT_LOGGED_IN
    ) {
      this.setState({ loginStatus: LOGIN_STATUS_NOT_LOGGED_IN });
      this.setState({ errorPassword: false });
      this.setState({ showLoginPop: false });
      this.setState({ showUserPop: false });
    }
  }

  onLoginDataSubmit() {
    const user = $('#userField').val();
    const pass = $('#passwordField').val();
    this.props.fetchAuth(user, pass);
  }
  focusInput() {
    this.setState({ errorPassword: false });
  }
  showLoginPop(showLoginPop) {
    this.setState({ showLoginPop: !showLoginPop });
  }

  showUserPop(showUserPop) {
    this.setState({ showUserPop: !showUserPop });
  }

  logOut(e) {
    $('#nav_main').css('z-index','');
    e.preventDefault();
    this.props.authLogOut();
    this.setState({ loginStatus: LOGIN_STATUS_NOT_LOGGED_IN });
    this.setState({ errorPassword: false });
    this.setState({ showLoginPop: false });
    this.setState({ showUserPop: false });
  }

  render() {
    const loginStatus = this.state.loginStatus;
    const showLoginPop = this.state.showLoginPop;
    const showUserPop = this.state.showUserPop;
    let modalErrorLogin = '';
    
    if (!_.isEmpty(this.props.auth) && !_.isEmpty(this.props.auth.modelEspecifico)) {
      localStorage.setItem(
        LOCALSTORAGE_AUTH_KEY,
        JSON.stringify(this.props.auth),
      );
      const name = this.props.auth.modelEspecifico.nombre;
      const surname = this.props.auth.modelEspecifico.apellido;
      const contra = this.props.auth.modelEspecifico.contra
      const inte = this.props.auth.modelEspecifico.inte
      newrelic.setCustomAttribute('contra', contra);
      newrelic.setCustomAttribute('inte', inte);

      return (
        <div className={s.welcome}>
          <button
            onClick={() => this.showUserPop(showUserPop)}
            className={showUserPop ? `${s.active}` : null}
          >
            <i className={`${s.user_icon} glyphicon glyphicon-user`} />
            {name} {surname}
            <i
              className={`${s.down_arrow} fa fa-sort-desc`}
              aria-hidden="true"
            />
          </button>
          {showUserPop
            ? <ul
                id="listaAccionesUser"
                className={`${s.listaAccionesUser} dropdown-menu`}
                role="menu"
                aria-labelledby="dropDownUser"
              >
                <li role="presentation">
                  <a role="menuitem" tabIndex="-1" href="mis_datos.php">
                    Mis Datos
                  </a>
                </li>
                <li role="presentation">
                  <a
                    role="menuitem"
                    tabIndex="-1"
                    onClick={e => this.logOut(e)}
                  >
                    Cerrar Sesión
                  </a>
                </li>
              </ul>
            : null}
        </div>
      );
    }
    if (loginStatus === LOGIN_STATUS_PENDING) {
      return <div />;
    }
    if (loginStatus === LOGIN_STATUS_NOT_LOGGED_IN) {
      switch(this.state.numError) {
       
        case '401':
         modalErrorLogin = <ModalErrorLogin />
          break;
        case '1000':
          modalErrorLogin =  <ModalUsuarioNoRegistrado />
          break;
        case '1002':
          modalErrorLogin = <ModalAltaPendiente fechaAlta={this.state.dataErrorLogin.data.errInfo.fechaAlta} />
          break;
        case '1003':
          localStorage.setItem('dni',$('#userField').val());
          localStorage.setItem('tipo',$('#tipoDoc').val()); 
          window.location.href = `${HOST_SERVER}smgnewsite/prepaga/update_password.php?wf=2&econsulta=1`;
          break;
        case '1005':
          modalErrorLogin =  <ModalUsuarioBloqueado />
          break;
        case '500':
          modalErrorLogin =  <ModalErrorConexionLogin />
        case '0':
          modalErrorLogin =  <ModalError msg="Se ha producido un error. Intente nuevamente"/>
        default:
          ''
      }

      return (
        <div>
           {modalErrorLogin}
          <div className={`${s.loginWrap} hidden-sm-down`}>
            <button
              type="button"
              onClick={() => this.showLoginPop(showLoginPop)}
              className={`${s.btn_ing} btn btn-sm`}
            >
              Iniciar Sesión
            </button>
            <button type="button" className={`${s.btn_reg} btn btn-sm`}>
              Regístrese
            </button>
            {showLoginPop
              ? <div>
                  <div className={`${s.loginDialogArrow}`} />
                  <div className={`${s.loginDialog} container`}>
                    <div className={`${s.row} form-group row`}>
                      <div className={`${s.col} col-lg-5`}>
                        <select id='tipoDoc'
                          className={`${s.loginTooltipTipoDoc} custom-select`}
                        >
                          <option value="DU">DNI</option>
                          <option value="LC">LC</option>
                          <option value="LE">LE</option>
                          <option value="PA">PA</option>
                        </select>
                      </div>
                      <div className={`${s.col} col-lg-7`}>
                        <input
                          autoFocus
                          id="userField"
                          type="number"
                          className="form-control"
                          placeholder="N° Documento"
                          maxLength="10"
                          onFocus={() => this.focusInput()}
                        />
                      </div>
                    </div>
                    <div className={`${s.row} form-group row`}>
                      <div className={`${s.col} col-lg-12`}>
                        <input
                          id="passwordField"
                          type="password"
                          className={
                            this.state.errorPassword
                              ? `form-control ${s.errorLogin}`
                              : `form-control`
                          }
                          placeholder="Contraseña"
                          onFocus={() => this.focusInput()}
                        />
                      </div>
                    </div>
                    <div className={`${s.row} form-group row`}>
                      <div className={`${s.col} col-lg-12`}>
                        <button
                          id="botonSubmit"
                          type="button"
                          onClick={() => this.onLoginDataSubmit()}
                          className={`${s.boton_rojo} btn btn-danger`}
                        >
                          Iniciar Sesión
                        </button>
                      </div>
                    </div>

                    <div className="form-group">
                      <Link to="/">¿Olvidaste tu contraseña?</Link>
                    </div>
                  </div>
                </div>
              : null}
          </div>
          <div className={`${s.loginWrapSmall} hidden-md-up visible-md-down`}>
            <a className="btn boton_gris" href="login_mobile.php">
              <i className="fa fa-user" />
            </a>
            <a className="btn boton_gris" href="index.php">
              <i className="fa fa-home" />
            </a>
          </div>
         
        </div>
      );
    }
  }
}

const mapStateToProps = state => ({
  auth: state.auth.loginResponse,
  loginError: state.auth.loginError,
});

export default connect(mapStateToProps, authActions)(withStyles(s)(Login));



// WEBPACK FOOTER //
// ./src/components/Login/Login.js